<template>
  <div class="price-container rounded-[10px] bg-white p-20">
    <div class="mb-10 flex w-446 items-center justify-between">
      <i class="iconfont icon-xiangzuo text-color-lightgray cursor-pointer" @click="handleLeft('add')"></i>
      <div class="price-list w-400 overflow-hidden">
        <div :style="{ width: '2000px', left: `${priceLeft}px` }" class="relative">
          <div class="price-item mr-16 flex h-90 w-190 items-center justify-center rounded-[10px]" :class="detail.diff1DayPrice < 0 ? '' : 'up'">
            <div class="text-center">
              <div class="text-color-gray mb-10 text-16">
                {{ $t('今日') }}
                <i v-if="detail.diff1DayPrice < 0" class="iconfont icon-xiajiang text-color-green text-10"></i>
                <i v-else class="iconfont icon-shangsheng1 text-color-red text-10"></i>
              </div>
              <div :class="detail.diff1DayPrice < 0 ? 'text-color-green' : 'text-color-red'">
                <span class="text-16 font-semibold">{{ monetaryUnit() }}{{ currencyTransform(detail.diff1DayPrice) }}</span>
                <span class="text-16"> ({{ detail.diff1Day > 0 ? '+' : '' }}{{ detail.diff1Day }}%)</span>
              </div>
            </div>
          </div>
          <div class="price-item mr-16 flex h-90 w-190 items-center justify-center rounded-[10px]" :class="detail.diff7DayPrice < 0 ? '' : 'up'">
            <div class="text-center">
              <div class="text-color-gray mb-10 text-16">
                {{ $t('本周') }}
                <i v-if="detail.diff7DayPrice < 0" class="iconfont icon-xiajiang text-color-green text-10"></i>
                <i v-else class="iconfont icon-shangsheng1 text-color-red text-10"></i>
              </div>
              <div :class="detail.diff7DayPrice < 0 ? 'text-color-green' : 'text-color-red'">
                <span class="text-16 font-semibold">{{ monetaryUnit() }}{{ currencyTransform(detail.diff7DayPrice) }}</span>
                <span class="text-16">({{ detail.diff7DayPrice > 0 ? '+' : '' }}{{ detail.diff7Day }}%)</span>
              </div>
            </div>
          </div>
          <div class="price-item mr-16 flex h-90 w-190 items-center justify-center rounded-[10px]" :class="detail.diff30DayPrice < 0 ? '' : 'up'">
            <div class="text-center">
              <div class="text-color-gray mb-10 text-16">
                {{ $t('本月') }}
                <i v-if="detail.diff30DayPrice < 0" class="iconfont icon-xiajiang text-color-green text-10"></i>
                <i v-else class="iconfont icon-shangsheng1 text-color-red text-10"></i>
              </div>
              <div :class="detail.diff30DayPrice < 0 ? 'text-color-green' : 'text-color-red'">
                <span class="text-16 font-semibold">{{ monetaryUnit() }}{{ currencyTransform(detail.diff30DayPrice) }}</span>
                <span class="text-16">({{ detail.diff30DayPrice > 0 ? '+' : '' }}{{ detail.diff30Day }}%)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <i class="iconfont icon-xiangyou text-color-lightgray cursor-pointer" @click="handleLeft('reduce')"></i>
    </div>

    <div>
      <el-tabs v-model="activeTab" class="demo-tabs" @tab-change="tab => (tabStorage = tab)">
        <el-tab-pane :label="$t('市场对比')" name="market">
          <div class="market-content px-20">
            <div class="market-filter mb-10 flex w-394 justify-center rounded-[10px] bg-[#F5F8FD] p-3">
              <div
                class="market-filter-item flex h-34 w-3/6 cursor-pointer items-center justify-center rounded-[10px] text-center"
                :class="[priceTab === 'onsale' ? 'active' : '']"
                @click="changePriceTab('onsale')"
              >
                {{ $t('价格') }}
              </div>
              <div
                class="market-filter-item flex h-34 w-3/6 cursor-pointer items-center justify-center rounded-[10px] text-center"
                :class="[priceTab === 'purchase' ? 'active' : '']"
                @click="changePriceTab('purchase')"
              >
                {{ $t('求购') }}
              </div>
            </div>
            <div class="market-list flex max-h-600 flex-wrap">
              <div
                v-for="platform in compareData.platformMarket"
                :key="platform.platform"
                class="market-item mb-10 mr-12 h-107 w-190 justify-between rounded-[10px] bg-[#F5F8FD] p-10"
              >
                <div class="text-color-gray justify-between">
                  <div>
                    <div class="mb-5 flex items-center justify-between">
                      <a :href="platform.link" class="flex items-center" target="_blank">
                        <div>
                          <i class="iconfont text-color-lightgray mr-5" :class="`icon-${platform.platform}`"></i>
                          <span class="text-color-lightgray text-16">{{ platform.platformName }}</span>
                        </div>
                      </a>

                      <ClientOnly>
                        <indexChart
                          v-if="platform?.trendList && showChart"
                          :id="`chart-${platform.platform}`"
                          class="inline-block"
                          :data="platform?.trendList"
                          :direction="1"
                          :last-day-end="true"
                          :x-key="0"
                          :y-key="priceTab == 'onsale' ? 1 : 2"
                          :class-name="'detail-chart'"
                        ></indexChart>
                      </ClientOnly>
                    </div>
                    <div class="text-color-orange mb-5 align-bottom text-20">
                      <a :href="platform.link" class="flex items-center" target="_blank">
                        <span class="whitespace-nowrap"
                          >{{ monetaryUnit() }} {{ priceTab == 'onsale' ? currencyTransform(platform.sellPrice) : currencyTransform(platform.biddingPrice) }}</span
                        >
                        <div
                          v-if="lowestPrice === platform.sellPrice && priceTab == 'onsale'"
                          class="ml-5 inline-block h-20 w-20 rounded-[4px] bg-[#0DAB62] pt-1 text-center text-12 text-white"
                        >
                          {{ $t('底') }}
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="flex justify-between">
                  <div>{{ priceTab == 'onsale' ? $t('在售') : $t('求购') }}： {{ priceTab == 'onsale' ? platform.sellCount : platform.biddingCount }}</div>
                  <div class="text-color-gray pr-10 text-right">
                    <span>{{
                      dayjs(platform.updateTime * 1000)
                        .locale(useI18n().locale.value != 'en' ? 'zh-CN' : 'en')
                        .fromNow()
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="detail.surviveNum && detail.surviveNum > 0" :label="$t('存世量')" name="servive">
          <div class="servive-content">
            <div>{{ $t('存世量') }}： {{ totalsurviveNum }}</div>
            <div class="wear-rate mb-20 flex">
              <div
                v-for="(relate, index) in categoryInfo.relatedList"
                :key="relate.itemId"
                class="rounded-[3px]"
                :class="[`rate-${index + 1}`, 'min-w-30']"
                :style="{ width: `${(relate.surviveNum / totalsurviveNum) * 100}%` }"
              >
                {{ Math.round((relate.surviveNum / totalsurviveNum) * 100) }}%
              </div>
            </div>
            <div class="relate-list">
              <div v-for="(relate, index) in categoryInfo.relatedList" :key="relate.itemId" class="mb-10 flex justify-between">
                <div class="flex items-center">
                  <div class="mr-5 h-16 w-5 rounded-[3px]" :class="relate.colorClass"></div>
                  <div>{{ relate.tag }}</div>
                </div>
                <div>{{ relate.surviveNum }}</div>
                <div style="color: #777">
                  {{ $t('更新于') }}
                  {{
                    dayjs(relate.updateTime * 1000)
                      .locale(useI18n().locale.value != 'en' ? 'zh-CN' : 'en')
                      .fromNow()
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('推算成交信息')" name="transication">
          <div class="transication-container">
            <div class="mb-10 flex justify-between">
              <div class="text-16">
                {{ $t('今日推算成交信息') }} <mytooltip placement="bottom" :content="$t('平台为三方交易平台')"><i class="iconfont icon-changjianwenti ml-5"></i></mytooltip>
              </div>

              <!-- <div class="cursor-pointer text-gray" @click="transicationDialogSwitch = true">{{ $t('成交记录') }}>></div> -->
            </div>
            <div class="mb-20 flex justify-between rounded-[10px] bg-[#F5F8FD] px-30 py-20">
              <div class="text-center">
                <div class="mb-10">
                  <div class="mb-10 text-gray-light">{{ $t('三方今日成交量') }}</div>
                  <div>{{ transicationRes?.overview?.transactionCount }}</div>
                </div>
                <div>
                  <div class="mb-10 text-gray-light">{{ $t('STEAM今日成交量') }}</div>
                  <div>{{ transicationRes?.steamOverview?.transactionCount }}</div>
                </div>
              </div>

              <div class="h-112 w-1 bg-[#EFF1F5]"></div>
              <div class="text-center">
                <div class="mb-10">
                  <div class="mb-10 text-gray-light">{{ $t('三方今日成交额') }}</div>
                  <div>{{ transicationRes?.overview?.transactionAmount }}</div>
                </div>
                <div>
                  <div class="mb-10 text-gray-light">{{ $t('STEAM今日成交额') }}</div>
                  <div>{{ transicationRes?.steamOverview?.transactionAmount }}</div>
                </div>
              </div>
              <div class="h-112 w-1 bg-[#EFF1F5]"></div>
              <div class="text-center">
                <div class="mb-10">
                  <div class="mb-10 text-gray-light">{{ $t('平均成交价') }}</div>
                  <div>{{ transicationRes?.overview?.avgPrice }}</div>
                </div>
                <div>
                  <div class="mb-10 text-gray-light">{{ $t('平均成交价') }}</div>
                  <div>{{ transicationRes?.steamOverview?.avgPrice }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="mb-10 text-16">{{ $t('历史成交查询') }}</div>
              <div v-if="transicationRes?.specialStyles?.length" class="mb-10 text-gray">
                <div class="flex items-center justify-between">
                  <div class="w-100">{{ $t('特殊款式') }}</div>
                  <el-select v-model="transicationQuery.specialStyles" multiple class="style-select" placeholder="选择特殊款式" size="large" style="width: 290px">
                    <el-option v-for="item in transicationRes?.specialStyles" :key="item.value" :label="item?.name" :value="item.value" />
                  </el-select>
                </div>
              </div>
              <div class="mb-10 text-gray">
                <div class="flex items-center justify-between">
                  <div class="w-100">{{ $t('图案模板') }}</div>
                  <el-input-number
                    v-model="tempPaintSeed"
                    :controls="false"
                    label=""
                    :min="1"
                    :max="1000"
                    :step="1"
                    :placeholder="$t('请填写 0-1000 范围内的图案模板')"
                    style="width: 290px; height: 40px"
                    @change="changeQuery('paintSeed', $event)"
                  >
                  </el-input-number>
                </div>
              </div>
              <div class="mb-10 text-gray">
                <div class="flex items-center justify-between">
                  <div class="w-100">{{ $t('皮肤编号') }}</div>
                  <el-input-number
                    v-model="tempPaintIndex"
                    :controls="false"
                    label=""
                    :min="1"
                    :step="1"
                    style="width: 290px; height: 40px"
                    @change="changeQuery('paintIndex', $event)"
                  >
                  </el-input-number>
                </div>
              </div>
              <div class="mb-10 text-gray">
                <div class="flex items-center justify-between">
                  <div class="w-100">{{ $t('磨损值') }}</div>
                  <el-input-number v-model="transicationQuery.wear" :controls="false" label="" :min="0" :max="1" style="width: 290px; height: 40px"> </el-input-number>
                </div>
              </div>
            </div>
            <div>
              <div class="btn h-40 w-full cursor-pointer rounded-[10px] bg-blue text-center leading-[40px] text-white" @click="openTransicationDialog">{{ $t('查询') }}</div>
              <div style="display: flex; flex-direction: row-reverse; color: #777777; margin-top: 0.5rem">
                <span>PS: {{ $t('全站成交采用大数据及算法得出,每个成交均可追踪到对应饰品') }} </span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog v-model="transicationDialogSwitch" width="1300" class="transication-dialog">
      <div class="px-20 pt-40">
        <div class="mb-30 text-22 text-black">{{ $t('历史成交记录') }}：{{ props.detail?.name }}</div>
        <transication
          v-if="transicationDialogSwitch"
          :info="dialogData"
          :transication-query="transicationQuery"
          :market-hash-name="props.detail.marketHashName"
          :special-styles="transicationRes?.specialStyles"
        ></transication>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { getDealInfo } from '~~/api/steam'
import indexChart from '~/pages/indexcomponents/indexChart.vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import transication from './transication.vue'
import mytooltip from '~/components/common/mytooltip.vue'

const { t } = useI18n()
const $t = t
dayjs.extend(relativeTime)

const props = defineProps({
  categoryInfo: {
    type: Object,
    default: function () {
      return {}
    }
  },
  detail: {
    type: Object,
    default: function () {
      return {}
    }
  },
  compareData: {
    type: Object,
    default: function () {
      return {}
    }
  }
})
const emit = defineEmits(['transactionDetailSwtich'])
const lowestPrice = ref(0)

for (let i = 0; i < props.compareData.platformMarket.length; i++) {
  if ((props.compareData.platformMarket[i].sellPrice && props.compareData.platformMarket[i].sellPrice < lowestPrice.value) || lowestPrice.value === 0) {
    lowestPrice.value = props.compareData.platformMarket[i].sellPrice
  }
}
let totalsurviveNum = ref(0)

for (let i = 0; i < props.categoryInfo.relatedList.length; i++) {
  props.categoryInfo.relatedList[i].colorClass = `rate-${i + 1}`
  totalsurviveNum.value += Number(props.categoryInfo.relatedList[i].surviveNum)
}
const tabStorage = useLocalStorage('detail-price-tab')
const activeTab = ref(tabStorage.value && tabStorage.value === 'servive' && props.detail?.surviveNum && props.detail?.surviveNum > 0 ? tabStorage.value : 'market')
const priceTab = ref('onsale')
const priceLeft = ref(0)

const handleLeft = diraction => {
  if (diraction === 'add') {
    if (priceLeft.value >= 0) {
      return
    }
    priceLeft.value += 410
  } else {
    if (priceLeft.value <= -410) {
      return false
    }
    priceLeft.value -= 410
  }
}
const showChart = ref(true)
const changePriceTab = tab => {
  showChart.value = false
  priceTab.value = tab
  setTimeout(() => {
    showChart.value = true
  }, 50)
}
const transicationDialogSwitch = ref(false)

const transicationQuery = ref({
  paintSeed: null,
  wear: null,
  styles: '',
  pageSize: 20,
  itemId: props.detail.itemId,
  sortBy: 'tradeTime',
  sortType: 'desc'
})
const transicationRes = ref({})
const dialogData = ref({})
onMounted(() => {
  getDealInfo({
    itemId: props.detail.itemId
  }).then(res => {
    transicationRes.value = res.data
  })
})
const tempPaintIndex = ref(null)
const tempPaintSeed = ref(null)

const changeQuery = (type, val) => {
  transicationQuery.value[type] = val ? [val] : []
}
const changeSort = sort => {
  transicationQuery.value.sortBy = sort.sortBy
  transicationQuery.value.sortType = sort.sortType
  openTransicationDialog()
}
const changeFilter = filter => {
  transicationQuery.value[filter.type] = filter.list
  openTransicationDialog()
}
const openTransicationDialog = noParams => {
  transicationDialogSwitch.value = true
  const tempParams = noParams === true ? { itemId: transicationQuery.value.itemId } : Object.assign({}, transicationQuery.value)
}
</script>

<style lang="scss" scoped>
.price-container {
  .price-list {
    height: 92px;

    .price-item {
      display: inline-block;
      padding-top: 10px;
      margin-top: 1px;
      background: linear-gradient(180deg, rgba(61, 202, 100, 0.2) 0%, rgba(61, 202, 100, 0) 100%), #ffffff;
      border: 1px solid rgba(13, 171, 98, 0.15);
      &.up {
        background: linear-gradient(180deg, rgba(255, 0, 32, 0.2) 0%, rgba(255, 0, 32, 0) 100%), #ffffff;
        border: 1px solid rgba(255, 0, 32, 0.1);
      }
    }
  }
  .demo-tabs {
    :deep(.el-tabs__header) {
      padding-left: 20px;
      padding-right: 30px;
    }
  }
  .market-filter {
    .market-filter-item {
      &.active {
        background: #ffffff;
        color: #0252d9;
      }
    }
  }

  .servive-content {
    .wear-rate {
      border-radius: 6px;
      overflow: hidden;
      div {
        height: 20px;
        text-align: center;
        color: #ffffff;
        border-radius: 0;
      }
    }
    .rate-1 {
      background-color: #008000;
    }
    .rate-2 {
      background-color: #5cb85c;
    }
    .rate-3 {
      background-color: #f0ad4e;
    }
    .rate-4 {
      background-color: #d9534f;
    }
    .rate-5 {
      background-color: #993a38;
    }
  }
  .transication-container {
    .style-select {
      :deep(.el-select__wrapper) {
        border-radius: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.transication-dialog {
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  .el-dialog__header {
    padding: 0;
    .el-dialog__close {
      width: 20px;
      height: 20px;
    }
  }
  .el-dialog__body {
    background: url(../../../assets/images/common/common-dialog-header-bg.png) top no-repeat;
    background-size: 1400px;
  }
}
</style>
